export const APP_CONFIG = {
  appName: 'CinemaHala',
  sinhalaName: 'සිනමාහල',
  tagline: 'The Home of Sri Lankan Cinema',
  domain: 'cinemahala.lk',
  contactEmail: 'hello@cinemahala.lk',
  defaultLanguage: 'si',
  features: {
    anonymousRating: true,
    singlishSearch: true,
    socialShareCard: true,
    cinemaClubForum: true,
    streamingAvailability: true,
    mediaInterviews: true
  }
};
